import { TaskManagementService } from 'app/modules/task/services/task-management.service';
import { Component, OnInit } from '@angular/core';
import { SharedService } from 'app/modules/common/services/shared-service';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { DateFilterTypes } from 'app/modules/common/enums/date-filter-enums';
import { UntypedFormControl } from '@angular/forms';
import moment from 'moment';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';

@Component({
    selector: 'app-task-selection-filters',
    templateUrl: './task-selection-filters.component.html',
    styleUrls: ['./task-selection-filters.component.scss'],
    standalone: false
})
export class TaskSelectionFiltersComponent implements OnInit {
    DateFilterType = DateFilterTypes;
    CommonDateFrom = new UntypedFormControl();
    CommonDateTo = new UntypedFormControl();
    Historial = false;
    isPrioritarias = false;
    EmpresaSelec = true;
    CurrentUser: any;

    OrdenList$ = [
        { text: 'Fecha', value: 'Fecha' },
        { text: 'Autor', value: 'Autor' },
        { text: 'Empresa', value: 'Empresa' },
        { text: 'F.Baja', value: 'FBaja' },
    ];

    responsibleAuthorTypes:string;
    responsibleModuleName:string;

    constructor(
        public selectionService: SelectionGenericService,
        private sharedService: SharedService,
        public taskManagementService: TaskManagementService
    ) {}

    ngOnInit(): void {
        this.taskManagementService.initTaskForm(1);
        this.responsibleAuthorTypes="GCMD"
        this.responsibleModuleName="task-selection";
        this.CurrentUser = this.sharedService.getCurrentUser();
        this.selectionService.taskSelectionModal.Historial = this.Historial;
        this.selectionService.taskSelectionModal.Prioritarias =
            this.isPrioritarias;
        this.selectionService.clearTaskFilter();
        this.selectionService.taskSelectionModal.EmpresaSelec = this.EmpresaSelec;
    }
    
    public SetDate(filterType: string, data: Date = null): void {
        switch (filterType) {     
          case 'commonDateFrom':                
                this.selectionService.FromDate = data ? moment(DateHelper.getUTCDateString(data)) : null;
            break;
    
          case 'commonDateTo':                
                this.selectionService.ToDate = data ? moment(DateHelper.getUTCDateString(data)) : null;
            break;
          default:
            break;
        }
    }    
       

    public onChange(name: string): void {
        switch (name) {
            case 'Historial':
                this.selectionService.taskSelectionModal.Historial =
                    this.Historial;
                break;
            case 'isPrioritarias':
                this.selectionService.taskSelectionModal.Prioritarias =
                    this.isPrioritarias;
                break;

            case 'EmpresaSelec':
                this.selectionService.taskSelectionModal.EmpresaSelec =
                    this.EmpresaSelec;
                break;
        }
    }

    public onChangeAutor(name: string, data: any = null): void {
        this.selectionService.taskSelectionModal.MedicoId = null;
        this.selectionService.taskSelectionModal.Autor = null;

        switch (name) {
            case 'Autor':
                this.selectionService.taskSelectionModal.TipoAutor = data
                    ? data
                    : null;
                if (data === 'Yo') {
                    this.selectionService.taskSelectionModal.Autor =
                        this.CurrentUser.abreviacion;
                } else if (data === 'G') {
                    // Author type is G when 'other user' is selected.
                    // Until another user is selected, the value is null.
                    this.selectionService.taskSelectionModal.Autor = null;
                } else if (data === 'M') {
                    this.selectionService.taskSelectionModal.MedicoId =
                        this.CurrentUser.medicoId;
                } else if (data === 'C') {
                    this.selectionService.taskSelectionModal.Autor =
                        this.CurrentUser.coordinador;
                }
                break;
            case 'User':
                this.selectionService.taskSelectionModal.Autor = data;
                break;
            case 'Medico':
                this.selectionService.taskSelectionModal.Autor =
                    data.selectedViewValue;
                this.selectionService.taskSelectionModal.MedicoId =
                    data.selectedValue;
                break;
            case 'Coordinator':
                this.selectionService.taskSelectionModal.Autor = data;
                break;
        }
    }
}
